import React from 'react'
import './cart.scss';
import Skeleton from '../../../components/Skeleton';
import classNames from 'classnames';
import {FormattedMessage} from 'react-intl';
import XClose from '../../../assets/icons0/x-close.svg';
import {LocalCartFooterDesktop, LocalCartFooterMobile} from './cart-footer';
import WarpOrderItem from './order-item';
import Browser from '../../../components/Browser';
import sortCartEndpoints from '../../../utilities/sort-cart-endpoints';
import {isServiceSalesPaused} from '../../../utilities/get-tag-value';
import {useErrorMessagesDispatch} from '../../checkout/error-messages-context';
import ErrorMessages from '../../checkout/error-messages';

const Cart = ({decrementEndpoint, incrementEndpoint, serviceById, localCartState, cartVisible, checkout, isLocalCartDeferred, setCartVisibility, stemCart, deleteEndpoint, availableEndpoints}) => {
    const {sortedEndpoints, hasInvalidEndpoints} = sortCartEndpoints({localCartState, availableEndpoints});
    const salesPaused = isServiceSalesPaused(serviceById.description);
    const errorDispatch = useErrorMessagesDispatch();
    React.useEffect(() => {
        if (hasInvalidEndpoints || salesPaused) {
            errorDispatch({
                type: 'add',
                payload: {
                    type: 'lightError',
                    title: <FormattedMessage defaultMessage='There are unavailable tickets in the order'/>,
                    description: <FormattedMessage defaultMessage='To place an order, remove tickets that are not available for purchase'/>,
                    showDefaultAction: true
                }
            });
        }
    }, [hasInvalidEndpoints, salesPaused]);
    return (
        <Browser>
            {!!localCartState.length && 
                <>
                    <div className={classNames('mw768-display-none local-cart-footer position-fixed z-index-2 ', {'local-cart-footer--cart-visible': cartVisible})}>
                        <LocalCartFooterMobile {...{localCartState, serviceById, deferred: isLocalCartDeferred, checkout, flag: cartVisible, setFlag: setCartVisibility, checkout, stemCart}}/>
                    </div>
                    <div className={classNames('pop-up-cart-backdrop', {'show': cartVisible})}>
                        <div className={classNames('pop-up-cart position-fixed background-color-white bottom-0 right-0 z-index-1', {'pop-up-cart--visible': cartVisible})}>
                            <div className='position-sticky top-0 background-color-white'>
                                <div className='display-flex justify-content-flex-end padding-1dot25rem-1rem mw768-padding-1dot25rem-2dot5rem'>
                                    <XClose className='display-block height-1dot5rem width-1dot5rem color-gray-500 cursor-pointer' onClick={() => setCartVisibility(false)}/>
                                </div>
                                <h3 className='display-sm semibold color-gray-900 padding-left-1dot25rem padding-right-1dot25rem mw768-padding-left-2dot5rem mw768-padding-right-2dot5rem padding-bottom-2rem'>
                                    <FormattedMessage defaultMessage='Cart'/>
                                </h3>
                            </div>
                            <div className='pop-up-cart__content padding-left-1dot25rem padding-right-1dot25rem mw768-padding-left-2dot5rem mw768-padding-right-2dot5rem'>
                                {sortedEndpoints.map((e, index) =>
                                    <div key={index} className={classNames('margin-bottom-1rem', {'margin-bottom-0': index === localCartState.length - 1})}>
                                        <React.Suspense fallback={<Skeleton/>}>
                                            <WarpOrderItem {...{endpointId: e.endpointId, cartEntry: e, serviceById: serviceById, decrementEndpoint, incrementEndpoint, deleteEndpoint, maxQuantity: e.maxQuantity, endpointAvailable: e.available && !salesPaused}}/>
                                        </React.Suspense>
                                    </div>
                                )}
                            </div>
                            <div className='hide-small local-cart-footer position-fixed bottom-0'>
                                <LocalCartFooterDesktop {...{localCartState, serviceById, deferred: isLocalCartDeferred, checkout, stemCart}}/>
                            </div>
                            <div className={classNames('error-messages-container', {'error-messages-container--visible': cartVisible})}>
                                <ErrorMessages/>
                            </div>
                        </div>
                    </div>
                </>
            }
        </Browser>
        
    )
};

export default React.memo(Cart);